import styled from 'styled-components';

export type TicketView = 'list' | 'board';

interface Props {
	value: TicketView;
	onChange: (next: TicketView) => void;
}

const Group = styled.div`
	display: inline-flex;
	align-items: center;
	overflow: hidden;
	border-radius: 6px;
	border: 1px solid #e2e8f0;
`;
const ToggleButton = styled.button<{$active: boolean; $bordered?: boolean}>`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 8px 12px;
	${p => p.theme.sys.font?.subheading?.['2']}
	border: 0;
	border-left: ${p => (p.$bordered ? '1px solid #e2e8f0' : 'none')};
	cursor: pointer;
	transition: color 0.15s, background 0.15s;
	background: ${p => (p.$active ? '#f1f5f9' : '#ffffff')};
	color: ${p => (p.$active ? '#0f172a' : '#64748b')};
	&:hover {
		background: ${p => (p.$active ? '#f1f5f9' : '#f8fafc')};
		color: ${p => (p.$active ? '#0f172a' : '#334155')};
	}
`;

export function ViewToggle({value, onChange}: Props) {
	return (
		<Group role="group" aria-label="View">
			<ToggleButton
				type="button"
				$active={value === 'list'}
				aria-pressed={value === 'list'}
				onClick={() => onChange('list')}
			>
				<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
					<rect x="1" y="2" width="12" height="1.5" rx="0.5" fill="currentColor" />
					<rect x="1" y="6" width="12" height="1.5" rx="0.5" fill="currentColor" />
					<rect x="1" y="10" width="12" height="1.5" rx="0.5" fill="currentColor" />
				</svg>
				List
			</ToggleButton>
			<ToggleButton
				type="button"
				$active={value === 'board'}
				$bordered
				aria-pressed={value === 'board'}
				onClick={() => onChange('board')}
			>
				<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
					<rect x="1" y="1" width="5" height="12" rx="1" fill="currentColor" />
					<rect x="8" y="1" width="5" height="12" rx="1" fill="currentColor" />
				</svg>
				Board
			</ToggleButton>
		</Group>
	);
}
